import * as React from "react";
import InputText from "../InputText";
import { useLocationStore } from "../../../state/storeLocation";
import { usePostMeta } from "../../../hooks/usePostMeta";

type Location = {
  id?: string;
  country: string | undefined;
  city: string | undefined;
  lat: string | undefined;
  lng: string | undefined;
};

const LocationPage = () => {
  const { customLocationData } = useLocationStore((state) => state);
  let inputCountry = React.useRef<HTMLInputElement>(null);
  let inputCity = React.useRef<HTMLInputElement>(null);
  let inputLat = React.useRef<HTMLInputElement>(null);
  let inputLng = React.useRef<HTMLInputElement>(null);

  const [IsEditing, setIsEditing] = React.useState({
    status: false,
    editId: "",
  });
  const { appendDataPost } = usePostMeta()


  const [location, setLocation] = React.useState<Location>({
    country: "",
    city: "",
    lat: "",
    lng: "",
  });
  const [locationEdit, setLocationEdit] = React.useState<Location>({
    id: "",
    country: "",
    city: "",
    lat: "",
    lng: "",
  });

  const resetInput = () => {
    setLocationEdit({
      id: "",
      country: "",
      city: "",
      lat: "",
      lng: "",
    });
    setLocation({
      country: "",
      city: "",
      lat: "",
      lng: "",
    });
    inputCity.current!.value = "";
    inputCountry.current!.value = "";
    inputLat.current!.value = "";
    inputLng.current!.value = "";
    setIsEditing({
      status: false,
      editId: "",
    });
  };
  const updateInput = () => {
    inputCity.current!.value = locationEdit.city ?? "";
    inputCountry.current!.value = locationEdit.country ?? "";
    inputLat.current!.value = locationEdit.lat ?? "";
    inputLng.current!.value = locationEdit.lng ?? "";
  };
  const changeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    let { name, value } = e.target;

    setLocation((prev) => ({ ...prev, [name]: value }));
    setLocationEdit({
      id: locationEdit?.id,
      country: inputCountry?.current?.value,
      city: inputCity?.current?.value,
      lat: inputLat?.current?.value,
      lng: inputLng?.current?.value,
    });
  };

  interface EditStatus {
    status: boolean;
    editId: string;
  }

  interface DataPost {
    meta: string;
    value: Location[];
  }

  const handleAddLocation = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    let list: Location[] = [];
    const isEdit =
      inputCountry.current &&
      inputCity.current &&
      inputLat.current &&
      inputLng.current &&
      IsEditing.status;

    if (isEdit) {
      const updateOneReturnAll = (customLocationData?.value as Location[]).map(
        (item: Location) => {
          if (item.id === locationEdit.id) {
            item.id = locationEdit.id;
            item.country = inputCountry?.current?.value;
            item.city = inputCity?.current?.value;
            item.lat = inputLat?.current?.value;
            item.lng = inputLng?.current?.value;
            return item;
          }
          return item;
        }
      );
      const data: DataPost = {
        meta: "location_list",
        value: updateOneReturnAll,
      };
      appendDataPost(data);
      resetInput();
      
    } else {
      if ( customLocationData.value?.length !== undefined && customLocationData?.id !== "" && location.country !== "" && location.city !== "" && location.lat !== "" && location.lng !== "") {
        console.log(customLocationData.value?.length);
        (customLocationData?.value as Location[]).map((item: Location) => {
          list.push(...[item]);
        });
        list.push({ ...location, id: new Date().getTime().toString() });
        const data: DataPost = {
          meta: "location_list",
          value: list,
        };

        appendDataPost(data);
        resetInput();
      } else if(location.country !== "" && location.city !== "" && location.lat !== "" && location.lng !== "") {
        list.push({ ...location, id: new Date().getTime().toString() });
        const data: DataPost = {
          meta: "location_list",
          value: list,
        };

        appendDataPost(data);
        resetInput();

      }
      if (customLocationData?.value?.[0]?.method === "" && location.country !== "" && location.city !== "" && location.lat !== "" && location.lng !== "") {
        {
          list.push({ ...location, id: new Date().getTime().toString() });
          const data: DataPost = {
            meta: "location_list",
            value: list,
          };
          appendDataPost(data);
          resetInput();
        }
      }
    }
  };

  type EditEvent = React.MouseEvent<HTMLParagraphElement> & {
    currentTarget: HTMLParagraphElement & {
      id: string;
    };
  };

  const handleEditOne = (e: EditEvent) => {
    const custom = (customLocationData?.value as Location[])?.find(
      (item) => item.id === e.currentTarget.id
    );
    setLocationEdit({
      id: custom?.id,
      country: custom?.country,
      city: custom?.city,
      lat: custom?.lat,
      lng: custom?.lng,
    });

    setIsEditing({
      status: true,
      editId: e.currentTarget.id,
    });
  };
  interface DeleteEvent extends React.MouseEvent<HTMLParagraphElement> {
    currentTarget: HTMLParagraphElement & {
      id: string;
    };
  }

  const handleDeleteOne = (e: DeleteEvent) => {
    const id = e.currentTarget.id;
    const custom = (customLocationData?.value as Location[])?.find(
      (item) => item.id === id
    );
    if (!custom) return;
    const list = (customLocationData?.value as Location[])?.filter(
      (item) => item.id !== id
    );
    const data: DataPost = {
      meta: "location_list",
      value: list,
    };
    appendDataPost(data);
  };

  React.useEffect(() => {
    const hasData =
      locationEdit.city !== "" &&
      locationEdit.country !== "" &&
      locationEdit.lat !== "" &&
      locationEdit.lng !== "" &&
      locationEdit.id !== "";
    if (hasData) {
      updateInput();
    }
  }, [locationEdit]);

  return (
    <div className="flex gap-4">
      <div className="left flex flex-col gap-2 p-3">
        <h2 className="text-lg">Custom Location Setting</h2>

        <InputText
          onChange={changeHandler}
          type="text"
          placeholder="Add Country"
          name="country"
          refs={inputCountry}
          value={locationEdit?.country}
        />
        <InputText
          onChange={changeHandler}
          type="text"
          placeholder="Add Location, City"
          name="city"
          refs={inputCity}
          value={locationEdit?.city}
        />
        <InputText
          onChange={changeHandler}
          type="text"
          placeholder="Add Latitude, lat"
          name="lat"
          refs={inputLat}
          value={locationEdit?.lat}
        />
        <InputText
          onChange={changeHandler}
          type="text"
          placeholder="Add Longitude, long"
          name="lng"
          refs={inputLng}
          value={locationEdit?.lng}
        />
        <InputText
          onClick={(e) => handleAddLocation(e as React.MouseEvent<HTMLButtonElement>)}
          text={IsEditing.status ? "Update Location" : "Add Location"}
          type="submit"
        />
      </div>

      <div className="right  bg-slate-100 p-3 ">
        <h2 className="text-lg p-1">Your Custom List of Location,</h2>
        {(customLocationData?.value as Location[])?.map((custom) => (
          <div
            key={custom?.id}
            id={custom?.id}
            className={`flex justify-between min-w-11 py-2 px-2 rounded-sm mb-2 ${
              custom?.id === IsEditing.editId ? "bg-yellow-100" : "bg-white"
            }  gap-20`}
          >
            <div className="flex gap-2">
              <p>{custom.country}</p>
              <p className="text-green-700">{custom.city}</p>
            </div>
            <div className="flex gap-2 ">
              <p
                onClick={handleEditOne}
                id={custom?.id}
                className="cursor-pointer font-bold text-yellow-400 hover:text-yellow-600 "
              >
                Edit
              </p>
              <p
                onClick={handleDeleteOne}
                id={custom?.id}
                className="cursor-pointer font-bold text-red-400 hover:text-red-600"
              >
                Delete
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LocationPage;
